import React from 'react'
import { PaginationContainer, PageButton, PageNav, Dots } from './styles'

const range = (start, end) => {
  const result = []
  for (let i = start; i <= end; i++) result.push(i)
  return result
}

const getVisiblePages = (count, page) => {
  if (count <= 7) return range(1, count)
  const siblings = 1
  const leftSiblingIndex = Math.max(page - siblings, 1)
  const rightSiblingIndex = Math.min(page + siblings, count)
  const showLeftDots = leftSiblingIndex > 2
  const showRightDots = rightSiblingIndex < count - 1

  if (!showLeftDots && showRightDots) {
    const leftRange = range(1, 3 + 2 * siblings)
    return [...leftRange, 'dots', count]
  }
  if (showLeftDots && !showRightDots) {
    const rightRange = range(count - (3 + 2 * siblings) + 1, count)
    return [1, 'dots', ...rightRange]
  }
  if (showLeftDots && showRightDots) {
    const middleRange = range(leftSiblingIndex, rightSiblingIndex)
    return [1, 'dots', ...middleRange, 'dots', count]
  }
  return [1, 'dots', ...range(Math.max(page - siblings, 2), Math.min(page + siblings, count - 1)), 'dots', count]
}

export const DefaultPagination = ({ count, page, onChange, showFirstButton, showLastButton, color }) => {
  if (count <= 1) return null

  const pages = getVisiblePages(count, page)

  return (
    <PaginationContainer>
      {showFirstButton && (
        <PageNav disabled={page === 1} onClick={(e) => onChange(e, 1)} $color={color}>
          {'\u00AB'}
        </PageNav>
      )}
      <PageNav disabled={page === 1} onClick={(e) => onChange(e, page - 1)} $color={color}>
        {'\u2039'}
      </PageNav>
      {pages.map((p, i) =>
        p === 'dots' ? (
          <Dots key={`dots-${i}`}>...</Dots>
        ) : (
          <PageButton key={p} $active={p === page} onClick={(e) => onChange(e, p)} $color={color}>
            {p}
          </PageButton>
        )
      )}
      <PageNav disabled={page === count} onClick={(e) => onChange(e, page + 1)} $color={color}>
        {'\u203A'}
      </PageNav>
      {showLastButton && (
        <PageNav disabled={page === count} onClick={(e) => onChange(e, count)} $color={color}>
          {'\u00BB'}
        </PageNav>
      )}
    </PaginationContainer>
  )
}
